import { Routes, Route } from "react-router-dom";
import { NotFound } from "../components/common";
import Edit from "../pages/Account/Edit";
import Home from "../pages/Account/Home";
import New from "../pages/Account/New";

const Account = () => {
  return (
    <div className="Account">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/edit" element={<Edit />} />
        <Route path="/new" element={<New />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Account;
